<template>

    <div class="banner">
        <!-- <img src="../assets/images/banner.png" alt=""> -->
        <img :src="bannerUrl" alt="">
        <!-- <top></top> -->
    </div>
</template>

<script>
export default {
    name: 'banner',
    data() {
        return {
            bannerUrl: ''
        }
    },
    mounted() {
        this.getBannerUrl();
    },
    methods: {
        getBannerUrl() {
            this.$httpOw('get', `/x/${this.$store.state.showID}/static/site/default.json`, {}, res => {
                console.log('bannerUrl', res);
                if(res.status == 200) {
                    this.bannerUrl = res.data.json?.banner?.index?.items[0]?.cn?.url;
                }
            })
        }
    },
}

</script>



<style scoped>
.banner{
    width: 100%;
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    /* PC端默认高度 */
    height: 400px;
}
.banner img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .banner {
        height: 120px; /* 移动端降低高度 */
        margin: 0;
    }
    
    .banner img {
        object-fit: cover;
        object-position: center top; /* 移动端聚焦图片顶部 */
    }
}

@media (max-width: 480px) {
    .banner {
        height: 100px; /* 小屏幕进一步降低高度 */
    }
}
</style>